var _defs, _line, _path, _line2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGateClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.77,
    y1: 16.18,
    x2: 12.77,
    y2: 58.82
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.79,35.14l-13.01-7.55c-1.33-.77-3,.19-3,1.73v28.51c0,.55.45,1,1,1h15.51c.55,0,1-.45,1-1v-20.09c0-1.07-.57-2.06-1.49-2.59Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 62.23,
    y1: 16.18,
    x2: 62.23,
    y2: 58.82
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.91,35.14l13.01-7.55c1.33-.77,3,.19,3,1.73v28.51c0,.55-.45,1-1,1h-15.51c-.55,0-1-.45-1-1v-20.09c0-1.07.57-2.06,1.49-2.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateClosed);
export default __webpack_public_path__ + "static/media/__Gate - Closed.0c787352ec421259f3510abc8d5c81dd.svg";
export { ForwardRef as ReactComponent };